import React, { forwardRef, useImperativeHandle, useState } from 'react'

import {
  AutenticacaoContainer,
  Botao,
  FormUnform,
  InputUnform,
  Spacer,
  Visao
} from 'src/componentes'
import { ModalBase } from 'src/componentes/modal-base'
import { SelectDefaultValue } from 'src/componentes/unform/select/selectDefaultValue'

import { Corpo, ContainerBotoes } from '../../styles'
import { createSchema } from './schema'
import {
  ModalIncluirDisciplinaCertificacaoProps,
  ModalIncluirDisciplinaCertificacaoRef
} from './tipos'

const ModalIncluir: React.ForwardRefRenderFunction<
  ModalIncluirDisciplinaCertificacaoRef,
  ModalIncluirDisciplinaCertificacaoProps
> = ({ backdrop, acaoPrimaria, opcoesProfessor }, ref) => {
  const { visao } = AutenticacaoContainer.useContainer()

  const [aberta, definirAberta] = useState(false)
  const [pronto, definirPronto] = useState(false)
  const [dadosIniciais, definirDadosIniciais] = useState<any>(null)
  const [indexDisciplina, definirIndexDisciplina] = useState<number | null>(
    null
  )
  const [modo, definirModo] = useState<'incluir' | 'editar'>('incluir')

  const fechar = () => {
    definirPronto(false)
    definirAberta(false)
    definirDadosIniciais(null)
    definirModo('incluir')
  }

  const abrir = (disciplina?: any) => {
    if (disciplina) {
      definirModo('editar')

      definirIndexDisciplina(disciplina.indexDisciplina)

      const professorId =
        disciplina?.professorDisciplinasCertificacao?.[0]?.idProfessor ??
        disciplina?.professorDisciplinasModuloCertificacao?.[0]?.idProfessor ??
        ''

      definirDadosIniciais({
        id: disciplina.id,
        nome: disciplina.nome,
        professor: professorId, // ✅ agora é o ID
        cargaHoraria: disciplina.cargaHoraria
      })
    } else {
      definirModo('incluir')
      definirDadosIniciais(null)
    }

    definirAberta(true)
    definirPronto(true)
  }

  useImperativeHandle(ref, () => ({
    fechar,
    abrir
  }))

  const acaoSucesso = async (dados: any) => {
    acaoPrimaria({
      ...dados,
      id: dadosIniciais?.id,
      modo,
      indexDisciplina
    })
    fechar()
  }

  return (
    <ModalBase aberta={aberta} backdrop={backdrop}>
      <Corpo style={{ width: '500px' }}>
        <h5>
          {modo === 'editar' ? 'Editar Disciplina' : 'Incluir Disciplina'}
        </h5>

        <Spacer padding="10px 0px" />

        {pronto && (
          <FormUnform
            key={dadosIniciais?.professor || modo}
            schema={createSchema}
            dadosIniciais={dadosIniciais}
            acaoSucesso={acaoSucesso}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                gap: '15px'
              }}
            >
              <div style={{ width: '100%' }}>
                <InputUnform
                  name="nome"
                  label="Nome da Disciplina"
                  obrigatorio
                  maxLength={200}
                />

                <SelectDefaultValue
                  id="select-professor"
                  name="professor"
                  label="Professor"
                  opcoes={opcoesProfessor}
                  obrigatorio
                  defaultValue={dadosIniciais?.professor} // ✅ ID
                  disabled={visao !== Visao.ParceiroCertificacao}
                />

                <InputUnform
                  name="cargaHoraria"
                  label="Carga Horária"
                  obrigatorio
                  maxLength={200}
                />
              </div>
            </div>

            <Spacer padding="10px 0px" />

            <ContainerBotoes>
              <Botao
                type="button"
                id="btn-cancelar"
                texto="Cancelar"
                tema="Secundario"
                onClick={fechar}
              />

              <Botao id="btn-salvar" texto="Salvar" type="submit" />
            </ContainerBotoes>
          </FormUnform>
        )}
      </Corpo>
    </ModalBase>
  )
}

export const ModalIncluirDisciplina = forwardRef(ModalIncluir)
